/* global rp$, $ajax */
'use strict';

require('public/js/elements/overlay-spinner');

const utils = require('public/js/helpers/utils');
const { loadFitmentConfirmationWrappers } = require('public/js/lib/fitment-confirmation-loader');

let THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	(function LoadFitmentConfirmationModule() {
		$onReady({
			rp$, window,
			label: 'load_fitment_confirmation',
			fn: function () {
				if (rp$('.fitment-confirmation-component-ajax-wrapper').length === 0 || utils.isBot()) {
					return;
				}

				loadFitmentConfirmationWrappers();
			},
		});
	})();
};

try {
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
